import React, { type CSSProperties, useMemo } from "react";
import CONFIG from "../../model/TSConfig";

interface Props {
  pcCompleted: number;
}

const HEIGHT = 8;

export default function KC_OnboardingStepper(props: Props) {
  const width = useMemo(() => {
    return `${Math.trunc(props.pcCompleted * 100)}%`;
  }, [props]);

  const rocketLeft = useMemo(() => {
    return `calc(${Math.trunc(props.pcCompleted * 100)}% - 25px)`;
  }, [props]);

  const rocketStyle = useMemo<CSSProperties>(() => {
    return {
      height: 37 * 2,
      position: "absolute",
      left: rocketLeft,
      top: -37,
      transform: "rotate(75deg)"
    };
  }, [rocketLeft]);

  const parentDivStyle = useMemo<CSSProperties>(() => {
    return {
      width: "100%",
      height: HEIGHT,
      minHeight: HEIGHT,
      maxHeight: HEIGHT,
      position: "relative",
      zIndex: 2
    };
  }, []);

  const childDiv1Style = useMemo<CSSProperties>(() => {
    return {
      width: "100%",
      height: HEIGHT,
      minHeight: HEIGHT,
      maxHeight: HEIGHT,
      background: "rgba(0,0,0,0.1)"
    };
  }, []);

  const childDiv2Style = useMemo<CSSProperties>(() => {
    return {
      width,
      height: HEIGHT,
      minHeight: HEIGHT,
      maxHeight: HEIGHT,
      background: "#0E0074",
      position: "absolute",
      top: 0,
      left: 0
    };
  }, [width]);

  return (
    <div style={parentDivStyle}>
      <div style={childDiv1Style}></div>
      <div style={childDiv2Style}></div>
      <img
        src={CONFIG.image_placeholder_url}
        data-twic-src="image:/cdm/kadow/pro/img/rocket_2.png"
        // data-src-transform="quality=100"
        style={rocketStyle}
      />
    </div>
  );
}
